import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { updateNavbarState } from './navbar_actions';

export const WORK_ORDERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('WORK_ORDERS');

// Per-WO "labels are being assigned" flag, so chips on other surfaces (row / detail
// header) can show a loading shimmer while the Add Label modal saves. Lives in the
// dedicated work_order_star_labels slice; stars/labels themselves are merged into the
// cached work order via the generated WORK_ORDERS updatePartialSuccess action.
export const SET_WORK_ORDER_LABELS_PENDING = 'WORK_ORDERS_SET_LABELS_PENDING';

export const setWorkOrderLabelsPendingInStore = (
	workOrderId: number | string,
	pending: boolean
) => ({ type: SET_WORK_ORDER_LABELS_PENDING, workOrderId, pending });

// Bumped after every successful star write (track / untrack / note / reminder set, snooze, stop),
// so lists filtered by star state — the Tracked view's groups — know to re-read.
export const WORK_ORDER_STAR_WRITTEN = 'WORK_ORDERS_STAR_WRITTEN';

export const workOrderStarWritten = () => ({ type: WORK_ORDER_STAR_WRITTEN });
const WORK_ORDERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WORK_ORDERS_CRUD_ACTION_CONSTANTS
);

const queryString = require('qs');

const originalFn = WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess;
WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess = function (workOrder) {
	return function (dispatch, getState) {
		const { navbar } = getState();
		const { backlinkTitle, navbarBackgroundColor } = navbar;
		if (navbar && navbar.backlinkTo) {
			const [path, queryParams] = navbar.backlinkTo.split('?');
			const urlSearchParams = new URLSearchParams(queryParams);
			urlSearchParams.delete('preserve');
			const backlinkTo = `${path}?${urlSearchParams.toString()}`;
			dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor));
		}
		dispatch(originalFn(workOrder));
	};
};

export { WORK_ORDERS_CRUD_ACTION_CREATORS };
